import type {AxiosInstance, AxiosPromise} from 'axios';
import {ENDPOINTS} from 'general/constants';
import type {ResponseProductType} from 'types/general';

export const getProduct = (
    instance: AxiosInstance,
    storeID: string,
): AxiosPromise<ResponseProductType> => {
    const urlPath = document.location.pathname
        .replace('landing-product/', '')
        .substring(1)
        .replace(new RegExp('/', 'g'), '%2F');

    return instance.get(`${ENDPOINTS.GET_PRODUCTS(storeID)}?urlPath=${urlPath}`);
};
